import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Row, Container, Col } from 'react-bootstrap';
import { Formik } from 'formik';
import FilterAccordionSelect from "../accordion/AccordionFilterSelect";
import FilterAccordionInput from "../accordion/AccordionFilterInput";
import { searchModel } from "./Search.model";
import { FaThList, FaThLarge } from "react-icons/fa";
import MediaQuery from "react-responsive";
import { SortNFilter } from "./SortNFilter";
export var SearchHeader = function SearchHeader(props) {
  var heading = props.heading,
      label = props.label,
      CategoryArray = props.CategoryArray,
      termChange = props.termChange,
      sortByChange = props.sortByChange,
      setGrid = props.setGrid,
      isGrid = props.isGrid;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "cb-search-header"
  }, heading), /*#__PURE__*/React.createElement("h3", {
    className: "cb-type-body-1 cb-search-label"
  }, label), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    className: "cb-accordion__search"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      faqFilter: "all",
      searchVal: ""
    },
    enableReinitialize: true
  }, function (childProps) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
      lg: "5"
    }, /*#__PURE__*/React.createElement(FilterAccordionInput, _extends({
      onChange: function onChange(e) {
        childProps.setFieldValue("searchVal", e);
        termChange(e);
      }
    }, childProps, props, {
      label: "Search for:",
      controlled: true,
      value: childProps.values.searchVal
    }))), /*#__PURE__*/React.createElement(MediaQuery, {
      minWidth: 991
    }, /*#__PURE__*/React.createElement(Col, {
      lg: "5"
    }, /*#__PURE__*/React.createElement(FilterAccordionSelect, {
      categories: CategoryArray,
      changeHandler: function changeHandler(e) {
        e.persist();
        sortByChange(e.target.value);
      }
    })), /*#__PURE__*/React.createElement(Col, {
      lg: 2
    }, /*#__PURE__*/React.createElement(GridToggle, {
      setGrid: setGrid,
      checked: isGrid
    }))), /*#__PURE__*/React.createElement(MediaQuery, {
      maxWidth: 990
    }, /*#__PURE__*/React.createElement(Col, {
      md: "12"
    }, /*#__PURE__*/React.createElement("button", {
      className: "cb-button-secondary mt-16",
      onClick: function onClick() {
        return setShow(true);
      }
    }, "Sort and Filter")), /*#__PURE__*/React.createElement(SortNFilter, _extends({}, props, childProps, {
      show: show,
      close: function close() {
        return setShow(false);
      },
      categories: CategoryArray
    }))));
  }))));
};

var GridToggle = function GridToggle(_ref) {
  var setGrid = _ref.setGrid,
      checked = _ref.checked;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-grid-toggle ".concat(checked ? "on" : "off")
  }, /*#__PURE__*/React.createElement("label", {
    for: "gridToggle",
    onClick: function onClick() {
      setGrid(false);
    }
  }, /*#__PURE__*/React.createElement(FaThList, null)), /*#__PURE__*/React.createElement("label", {
    for: "gridToggle",
    onClick: function onClick() {
      setGrid(true);
    }
  }, /*#__PURE__*/React.createElement(FaThLarge, null)), /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: checked,
    name: "gridToggle",
    className: "d-none"
  }));
};